import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31de050d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wait-payment" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "wait-payment__title" }, "Your payment is processing", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "wait-payment__description" }, " We're processing your payment. Please wait ", -1))

import MainLoader from "@/components/MainLoader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'WaitPayment',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainLoader, {
      class: "wait-payment__loader",
      primary: ""
    }),
    _hoisted_2,
    _hoisted_3
  ]))
}
}

})